/* eslint-disable @typescript-eslint/ban-ts-comment */
import { FileWithPath, useDropzone } from "react-dropzone";
import { ReactNode, useCallback, useState } from "react";
import { useMutation } from "@tanstack/react-query";
import { AddImage } from "../../api/UploadImage/UploadImg";
interface UploadProgress {
    [key: string]: number;
}

interface FilePreviews {
    [key: string]: string;
}
interface MultipleUploadProps {
    folder: string;
    children: ReactNode;
    onFileUploaded: (fileName: string, questionId: number) => void;
    acceptedFiles?: { [fileType: string]: string[] };
    questionId: number;
}

const MultipleUpload = ({
    folder,
    children,
    onFileUploaded,
    acceptedFiles = { "image/*": [] },
    questionId
}: MultipleUploadProps) => {
    const [uploadProgress, setUploadProgress] = useState<UploadProgress>({}); 
    const [filePreviews, setFilePreviews] = useState<FilePreviews>({});


    const { mutate } = useMutation({
        mutationFn: (file: FileWithPath) => {
            const formData = new FormData();
            formData.append("file", file);
            //@ts-expect-error
            return AddImage(formData, folder, questionId);
        },
        onSuccess: (response, file: FileWithPath) => {
            onFileUploaded(response.url, questionId);
            setUploadProgress(prev => ({ ...prev, [file.name]: 100 }));
        },
        onError: (file: FileWithPath) => {
            setUploadProgress(prev => ({ ...prev, [file.name]: 0 }));
        }
    });

    const onDrop = useCallback((acceptedFiles: FileWithPath[]) => {
        acceptedFiles.forEach(file => {
            const reader = new FileReader();
            reader.onload = () => {
                const result = reader.result;
                if (typeof result === "string") {
                    setFilePreviews(prev => ({ ...prev, [file.name]: result }));
                }
            };
            reader.readAsDataURL(file);
            mutate(file);
        });
    }, [mutate]);
    const { getRootProps, getInputProps } = useDropzone({
        onDrop,
        accept: acceptedFiles,
        multiple: true
    });

    return (
        <div>
            <div {...getRootProps({ className: "dropzone" })}>
                <input {...getInputProps()} />
                {children}
            </div>
            <div className="flex flex-wrap gap-3">
    {Object.keys(filePreviews).map((fileName) => (
        <div className="mt-5" key={fileName}>
            <img src={filePreviews[fileName]} alt={fileName} className="size-[180px] object-cover" />
            <div className="bg-[#4379EE] h-2 max-w-[180px]" style={{ width: `${uploadProgress[fileName]}%` }}>
            </div>
        </div>
    ))}
</div>        </div>
    )
}

export default MultipleUpload